import { FunctionComponent } from 'react';

import { JobAgreementsLabels } from 'models/JobAgreement';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutJobsJobBoxDescription: FunctionComponent<Props> = ({
    job,
    jobCity,
    icons,
    titles,
}) => {
    return (
        <StyledComponent
            className="public-layout-jobs-job-box-description"
        >
            <div className="container">
                {job?.jobTime && (
                    <div className="container-element">
                        <img
                            className="icon"
                            src={icons?.bullet}
                            loading="lazy"
                            alt={icons.bulletAlt}
                            width="20"
                            height="19"
                        />
                        <div
                            className="element-content"
                            dangerouslySetInnerHTML={{ __html: job?.jobTime?.name }}
                        />
                    </div>
                )}
                <div className="container-element">
                    <img
                        className="icon"
                        src={icons?.cv}
                        loading="lazy"
                        alt={icons.cvAlt}
                        width="16"
                        height="20"
                    />
                    <div
                        className="element-content"
                        dangerouslySetInnerHTML={{ __html: job?.isCvRequired ? titles?.cvRequired : titles?.cvFree }}
                    />
                </div>

                {Array.isArray(job?.jobAgreements) && job?.jobAgreements.length > 0 &&
                job?.jobAgreements.some(jobAgreement=>jobAgreement.name === JobAgreementsLabels.All) ?
                    job?.jobAgreements.filter(jobAgreement=>jobAgreement.name === JobAgreementsLabels.All)
                        .map(jobAgreement => (
                            <div
                                key={jobAgreement?.id}
                                className="container-element"
                            >
                                <img
                                    className="icon"
                                    src={icons?.offer}
                                    loading="lazy"
                                    alt={icons.offerAlt}
                                    width="16"
                                    height="20"
                                />
                                <div
                                    className="element-content"
                                    dangerouslySetInnerHTML={{ __html: jobAgreement?.name }}
                                />
                            </div>
                        ))
                    :
                    job?.jobAgreements
                        .map(jobAgreement => (
                            <div
                                key={jobAgreement?.id}
                                className="container-element"
                            >
                                <img
                                    className="icon"
                                    src={icons?.offer}
                                    loading="lazy"
                                    alt={icons.offerAlt}
                                    width="16"
                                    height="20"
                                />
                                <div
                                    className="element-content"
                                    dangerouslySetInnerHTML={{ __html: jobAgreement?.name }}
                                />
                            </div>
                        ))
                }

                {Array.isArray(job?.jobModes) && job?.jobModes.length > 0 && job?.jobModes
                    .map(jobMode => (
                        <div
                            key={jobMode?.id}
                            className="container-element"
                        >
                            <img
                                className="icon"
                                src={icons?.mode}
                                loading="lazy"
                                alt={icons.modeAlt}
                                width="20"
                                height="20"
                            />
                            <div
                                className="element-content"
                                dangerouslySetInnerHTML={{ __html: jobMode?.name }}
                            />
                        </div>
                    ))
                }

                {jobCity?.companyFullAddress && (
                    <div className="container-element">
                        <img
                            className="icon"
                            src={icons?.location}
                            loading="lazy"
                            alt={icons.locationAlt}
                            width="14"
                            height="20"
                        />
                        <div
                            className="element-content element-content-company-address"
                            dangerouslySetInnerHTML={{ __html: jobCity?.companyFullAddress }}
                        />
                    </div>
                )}

                {job?.jobExperience && (
                    <div className="container-element">

                        <img
                            className="icon"
                            src={icons?.exp}
                            loading="lazy"
                            alt={icons.expAlt}
                            width="19"
                            height="17"
                        />
                        <div
                            className="element-content"
                            dangerouslySetInnerHTML={{ __html: job?.jobExperience?.name }}
                        />
                    </div>
                )}
            </div>
        </StyledComponent>
    );
};

export default PublicLayoutJobsJobBoxDescription;